import { createSelector } from 'reselect';

import type Transaction from '~/types/Transaction';

import { type TransactionsState } from '~/reducers/transactions';
import { getTransactionObjectIdFromProps } from '~/selectors/props.selectors';
import { TransactionStatus } from '~/types/Transaction';

import { type ApplicationState } from '../store';

const getTransactionsState = (state: ApplicationState) => state.transactions;

export const getTransactionsData = createSelector(
  getTransactionsState,
  (transactionsState: TransactionsState) => transactionsState.data,
);

// FIXME: This selectors no longer work outside the context of batch
export const getSuccessfulTransactions = createSelector(getTransactionsData, (transactionsData) =>
  Object.values(transactionsData).filter(
    (transaction) => transaction.status === TransactionStatus.SUCCESS,
  ),
);

export const getTransactionByObjectId = createSelector(
  getTransactionsData,
  getTransactionObjectIdFromProps,
  (transactionsData, transactionId): Transaction | undefined => transactionsData[transactionId],
);

export const getFetchingTransactions = createSelector(
  getTransactionsState,
  (transactionsState): boolean => transactionsState.fetchingTransactions,
);

export const getSuccessfulTransactionsCount = createSelector(
  getTransactionsState,
  (transactionsState): number => transactionsState.successfulTransactionsCount,
);

export const getFirstSuccessfulTransactionObjectId = createSelector(
  getTransactionsState,
  (transactionsState) => transactionsState.firstSuccessfulTransactionObjectId,
);
